import dayjs from 'dayjs';
import { useDisplayTime } from 'src/utils/hooks';
import { useCurrentDateTimer } from 'src/utils/hooks/use-current-date-timer';

export const usePartnerLocalTime = (timeZone?: string) => {
  const now = useCurrentDateTimer();

  const currentDate = dayjs(now).tz(timeZone);

  const { displayTime } = useDisplayTime({
    showTimezone: true,
    tz: timeZone,
  });

  return {
    currentDate,
    formattedDate: currentDate.format('ddd, MMM D, YYYY'),
    formattedTime: displayTime(currentDate),
  };
};
